import * as React from 'react'
import * as service from '@owl-nest/services'
import { internalError, alert } from '@owl-nest/redux-wrapper/src/messages/actions'

export function useAuthFailureMessage(
  auth:
    | service.user.UseAuthExisting
    | service.user.UseAuthNew
    | service.user.UseAuthUnknown
    | service.user.UseAuthKnown,
): void {
  const dispatch = service.message.useDispatch()

  React.useEffect(() => {
    if (!auth.failure) {
      return
    }
    if (auth.failure.status === 429) {
      dispatch(alert('Too many login attempts. Please try later.', { focus: true, context: 'login' }))
    } else if (auth.failure.status >= 500) {
      dispatch(internalError({ context: 'login' }))
    }
  }, [auth.failure])
}
